import React, { Component } from "react";
import styled, { withTheme } from "styled-components";
import axios from "axios";
import ReactTable from "react-table";
import { API_URL, DOWNLOAD_URL } from "../constants";
import { PageWrapper, FlexWrapper, Header, Modal, Datepicker, Button,Toast} from "../components";
import "react-table/react-table.css";
import moment from "moment";
import { isEmpty, get } from "lodash";
import { createGlobalStyle } from "styled-components";
import * as actions from "./Actions";
import store from "./Store";

const GlobalStyle = createGlobalStyle`
  body>div{
    max-width:100% !important;
  }
`;

const ImageWrap = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  & > a {
    display: block;
    width: calc(20% - 20px);
    margin: 10px 10px;
    & > img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
`;

const TableWrap = styled.div`
  position: relative;
  .ReactTable.-striped.-highlight {
    padding-bottom: 50px;
  }
  .rt-thead.-header {
    background: #078489;
    color: #fff;
    position: fixed;
    top: 60px;
    width: 97%;
  }
  .rt-td {
    white-space: normal !important;
  }
  .rt-tr-group {
    padding-top: 34px;
  }
  .pagination-bottom {
    position: fixed;
    bottom: 0;
    width: 100%;
    background: #078489;
    color: #fff;
  }
  .ReactTable .-pagination .-btn[disabled] {
    color: #fff;
    opacity: 0.9;
  }
  .ReactTable .-pagination .-btn {
    color: #fff;
  }
  .rt-tbody {
    /* max-height: calc(100vh - 93px); */
  }
`;
const ReceiptWrapper = styled.div`
  width: 100%;
  padding: 20px 10px;
  & > h4 {
    font-size: 16px;
    padding-bottom: 10px;
    color: #212121;
    margin-bottom: 10px;
    border-bottom: 1px solid #dcdcdc;
  }
`;

const DatetWrapper = styled.div`
  width: 60%;
  padding: 20px 10px;
  & > h4 {
    font-size: 16px;
    padding-bottom: 10px;
    color: #212121;
    margin-bottom: 10px;
    border-bottom: 1px solid #dcdcdc;
  }
`;

const ProductWrapper = styled.div`
  width: 100%;
  padding: 20px 10px;
  & > h4 {
    font-size: 16px;
    padding-bottom: 10px;
    color: #212121;
    margin-bottom: 10px;
    border-bottom: 1px solid #dcdcdc;
  }
`;

class ScanReceiptAutomation extends Component {
  state = {
    loader: false,
    bugData: [],
    userReceiptData: [],
    showModal: false,
    newImages: [],
    newProductImages: [],
    submissionDate: new Date(),
    isLoadingDate: false,
    pageUpdate: store.getactivePage()
  };
  constructor(props) {
    super(props);
    // this.getUserReceipt()
  }

  componentDidMount() {
    this.getUserReceipt();
    store.on("storeUpdated",this.getUserReceipt);
  }

  componentWillUnmount() {
    store.removeListener("storeUpdated", this.getUserReceipt);
  }


  getUserReceipt = async () => {
    var isData = store.getactivePage();
   // console.log(isData.response);
    if (isData.response && isData.response.length !== 0) {
      this.setState({ userReceiptData: isData.response });
    } else {
    const query = {
      filter: {
        include: ["userReceiptProduct", "user"],
        order: ["id desc"]
        // offset: 0,
        // limit: 50
      }
    };
    try {
      const { data } = await axios.get(`${API_URL}/UserReceipts`, {
        params: { filter: query.filter }
      });
     // console.log(data)
      actions.handleActions(data);
      this.setState({ userReceiptData: data });
    } catch (error) {
      console.log(error);
    }
  }
  };

  viewBills = (images, productImages) => {
    const newImages = images === "" ? [] : JSON.parse(images);
    const newProductImages = productImages === "" ? [] : JSON.parse(productImages);
    this.setState({
      newImages,
      newProductImages: newProductImages ? newProductImages : [],
      showModal: true
    });
  };

  editDate = (id, prevDate) => {
    this.setState({ rowId: id, prevDate, showDateModal: true });
  };

  getGsPoints = userReceiptProduct => {
    let productGsPoints = 0;
    userReceiptProduct.forEach(item => {
      productGsPoints =
        productGsPoints +
        (((item.modifiedPrice || item.originalPrice || 0) * item.greenScore) /
          ((100 / item.greenScore) * 1200)) *
          100;
    });
    return Math.round(productGsPoints);
  };

  handleChangeDate = date => {
    this.setState({
      submissionDate: date
    });
  };

  submitDateData = async () => {
    this.setState({ isLoadingDate: true });
    try {
      await axios.patch(`${API_URL}/UserReceipts/${this.state.rowId}`, {
        originalSubmissionDate: this.state.prevDate,
        createdAt: this.state.submissionDate
      });
      this.setState({ isLoadingDate: false, showDateModal: false });
      this.getUserReceipt();
    } catch (error) {
      console.log(error);
    }
    this.setState({ isLoadingDate: false });
  };

  handleNewPage = async (row, pageName) => {
    if (pageName == "view") {
      this.props.history.push({
        pathname: `/view-purchased-automation-native/${get(row.original, "id", "")}`
      });
    } else if (pageName == "add") {
      this.props.history.push({
        pathname: `/add-purchased-products-native/${get(
          row.original,
          "id",
          ""
        )}/${get(row.original, "userId", "")}`,
        state: {
          listName: get(row.original, "userReceiptProduct.0.listName", ""),
          zipCode: get(row.original, "userReceiptProduct.0.zipCode", "")
        }
      });
    }
  };

  render() {
    const {
      userReceiptData,
      showModal,
      showDateModal,
      submissionDate,
      isLoadingDate,
      openToast
    } = this.state;
    const { theme } = this.props;
    return (
      <React.Fragment>
        <GlobalStyle />
        <Header
          icon="arrowBack"
          title="Scan Receipt Automation"
          onClickBack={() => this.props.history.goBack()}
          backgroundColor="#124b5f"
          style={{ minWidth: "100%" }}
          color="#fff"
        />
        <PageWrapper
          viewPadding="0 20px"
          height="auto"
          modifyPadding="0 20px"
          style={{ marginTop: 60 }}
        >
          
          <TableWrap>
            <ReactTable
              data={userReceiptData}
              columns={[
                {
                  Header: "ID",
                  accessor: "id",
                  width: 50
                },
                {
                  Header: "Actual Purchased Date",
                  accessor: "createdAt",
                  Cell: row =>
                    row.original.createdAt
                      ? moment(get(row.original, "createdAt", "")).format(
                          "DD MMM YYYY HH:mm:ss"
                        )
                      : "",
                  minWidth: 150
                },
                {
                  Header: "UserId",
                  accessor: "userId",
                  width: 70
                },
                
                {
                  Header: "UserEmail",
                  Cell: row => get(row.original, "user.email", ""),
                  minWidth: 200
                },
                
                {
                  Header: "Store Name",
                  accessor: "storeName",
                  Cell: row =>
                    get(row.original, "userReceiptProduct.0.storeName", ""),
                  width: 200
                },
                {
                  Header: "Total Gs Points",
                  Cell: row =>
                    this.getGsPoints(
                      get(row.original, "userReceiptProduct", [])
                    ),
                  width: 200
                },
                {
                  Header: "Store Image",
                  accessor: "storeImage",
                  Cell: row =>
                    isEmpty(
                      get(row.original, "userReceiptProduct.0.storeImage", "")
                    ) ? (
                      <img
                        src={require("../static/images/no-image.png")}
                        height="100px"
                        alt={"demo"}
                      />
                    ) : (
                      <img
                        src={get(
                          row.original,
                          "userReceiptProduct.0.storeImage",
                          ""
                        )}
                        height="70px"
                        width="100px"
                        alt={get(
                          row.original,
                          "userReceiptProduct.0.storeImage",
                          ""
                        )}
                      />
                    ),
                  height: 100,
                  minWidth: 150
                },
                {
                  Header: "Action",
                  Cell: row => (
                    <FlexWrapper alignItems="center">
                      {/* <Link
                        style={{ color: '#124b5f', textDecoration: 'underline' }}
                        to={`/view-purchased-automation-native/${get(row.original, 'id', '')}`}>
                        View Products
                      </Link>{' '} */}
                      <span
                        style={{
                          color: "#124b5f",
                          textDecoration: "underline"
                        }}
                        onClick={() => this.handleNewPage(row, "view")}
                      >
                        {" "}
                        View Products
                      </span>
                      {/* <Link
                        style={{ color: '#124b5f', textDecoration: 'underline' }}
                        to={`/add-purchased-products-native/${get(row.original, 'id', '')}/${get(
                          row.original,
                          'userId',
                          ''
                        )}`}>
                        Add Products
                      </Link> */}
                      <span
                        style={{
                          color: "#124b5f",
                          textDecoration: "underline"
                        }}
                        onClick={() => this.handleNewPage(row, "add")}
                      >
                        {" "}
                        Add Products
                      </span>
                      <span
                        style={{
                          color: "#124b5f",
                          textDecoration: "underline"
                        }}
                        onClick={() =>
                          this.viewBills(
                            get(row.original, "image", "[]"),
                            get(row.original, "productImages", "[]")
                          )
                        }
                      >
                        {" "}
                        View Receipts
                      </span>
                      <span
                        style={{
                          color: "#124b5f",
                          textDecoration: "underline"
                        }}
                        onClick={() =>
                          this.editDate(
                            get(row.original, "id", ""),
                            get(row.original, "createdAt", "")
                          )
                        }
                      >
                        {" "}
                        Edit Date
                      </span>
                    </FlexWrapper>
                  ),
                  width: 150
                }
              ]}
              defaultPageSize={50}
              // pageSize={5}
              minRows={0}
              resizable={false}
              className="-striped -highlight"
              onPageChange={pageIndex => {
                console.log("pageIndex", pageIndex);
              }}
            />
          </TableWrap>
        </PageWrapper>
        <Modal
          title={"Receipts"}
          show={showModal}
          hide={!showModal}
          style={{ minHeight: 400 }}
          maxWidth="800px"
          onClose={() => this.setState({ showModal: false })}
        >
          <ReceiptWrapper>
            <h4>Receipt Images</h4>
            <React.Fragment>
              <ImageWrap>
                {get(this.state, "newImages", []).map(item => {
                  return (
                    <a href={`${DOWNLOAD_URL}/${item}`} target="_blank">
                      <img
                        src={`${DOWNLOAD_URL}/${item}`}
                        height="100px"
                        width="100px"
                        objectFit="cover"
                      />
                    </a>
                  );
                })}
              </ImageWrap>
            </React.Fragment>
          </ReceiptWrapper>
          <ProductWrapper>
            <h4>Products Images</h4>
            <React.Fragment>
              <ImageWrap>
                {get(this.state, "newProductImages", []).map(item => {
                  return (
                    <a href={`${DOWNLOAD_URL}/${item}`} target="_blank">
                      <img
                        src={`${DOWNLOAD_URL}/${item}`}
                        height="100px"
                        width="100px"
                        objectFit="cover"
                      />
                    </a>
                  );
                })}
              </ImageWrap>
            </React.Fragment>
          </ProductWrapper>
        </Modal>
        <Modal
          title={"Edit Actual Purchased Date"}
          show={showDateModal}
          hide={!showDateModal}
          style={{ minHeight: 400 }}
          maxWidth="800px"
          onClose={() => this.setState({ showDateModal: false })}
        >
           {/* <Toast
                  open={openToast}
                  message="Product Successfully Confirmed!"
                  onClose={this.handleClose}
                /> */}
          <DatetWrapper>
            <Datepicker
              label="Actual Purchased Date"
              value={moment(submissionDate).format("DD MMM YYYY")}
              selected={submissionDate}
              onChange={this.handleChangeDate}
            />
            <Button
              style={{ lineHeight: 2.4, marginBottom: 20 }}
              volume="filled"
              label="Update"
              onClick={this.submitDateData}
              disabled={isLoadingDate}
              isLoading={isLoadingDate}
            />
          </DatetWrapper>
        </Modal>
      </React.Fragment>
    );
  }
}
export default withTheme(ScanReceiptAutomation);



// WEBPACK FOOTER //
// ./src/pages/ScanReceiptAutomation.js